import { Market } from '../markets/interfaces';
import { RequestResult } from '../../../interfaces/requests';

export const RETRIEVE_ALL_CACHED_MARKETS = 'marketList/RETRIEVE_ALL_CACHED_MARKETS';
export const RETRIEVE_ALL_CACHED_MARKETS_SUCCESS = 'marketList/RETRIEVE_ALL_CACHED_MARKETS_SUCCESS';
export const RETRIEVE_ALL_CACHED_MARKETS_FAILURE = 'marketList/RETRIEVE_ALL_CACHED_MARKETS_FAILURE';

export interface RetrieveAllCachedMarketsAction {
  type: typeof RETRIEVE_ALL_CACHED_MARKETS;
}

export type CachedMarket = Pick<Market, 'name' | 'slug' | 'ISOCode3Letter' | 'ISOCode2Letter'>;

export interface RetrieveAllCachedMarketsSuccessAction {
  type: typeof RETRIEVE_ALL_CACHED_MARKETS_SUCCESS;
  marketList: CachedMarket[];
}

export interface RetrieveAllCachedMarketsFailureAction {
  type: typeof RETRIEVE_ALL_CACHED_MARKETS_FAILURE;
  error: RequestResult;
}
